export const ONE_SETTINGS_RESET_STATE = 'ONE_SETTINGS_RESET_STATE';
export const ONE_SETTINGS_CURRENT_ITEM = 'ONE_SETTINGS_CURRENT_ITEM';
 
export const ONE_SETTINGS_REQUEST_LOADING = 'ONE_SETTINGS_REQUEST_LOADING';
export const ONE_SETTINGS_REQUEST_SUCCESS = 'ONE_SETTINGS_REQUEST_SUCCESS';
export const ONE_SETTINGS_REQUEST_FAILED = 'ONE_SETTINGS_REQUEST_FAILED';
 
export const ONE_SETTINGS_CURRENT_ACTION = 'ONE_SETTINGS_CURRENT_ACTION';
export const ONE_SETTINGS_RESET_ACTION = 'ONE_SETTINGS_RESET_ACTION';